<template>
        <footer>
            <div class="footer__area-two">
 
                <div class="footer__top-two">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-4 col-lg-5 col-md-6"> 
                            </div>
                            <div class="col-xl-2 col-lg-3 col-sm-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Information</h4>
                                    <div class="footer-link-list">
                                        <ul class="list-wrap">
                                            <li><router-link to="/Berita"> Berita </router-link> </li>
                                            <li><router-link to="/data_pegawai"> Data Pegawai </router-link> </li>
                                            <li><router-link to="/struktur_organisasi"> Struktur Organisasi </router-link> </li>
                                            <li><router-link to="/visi_misi"> Visi Misi </router-link> </li>
 
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-sm-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Galeri</h4>
                                    <div class="footer-link-list">
                                        <ul class="list-wrap">
                                            <li>
                                                <router-link to="/gallery_foto">
                                                    Foto
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link to="/gallery_video">
                                                    Video
                                                </router-link>
                                            </li>
  
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Foto Kegiatan</h4>
                                    <div class="footer-instagram">
                                        <ul class="list-wrap">
                                            <li>
                                                <a href="javascript:void(0)" v-for="(item, index) in list_data" :key="index">
                                                    <img
                                                        :src="$store.state.UPLOADS+item.file" alt="Apexa" /></a>
                                            </li>
                                             
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer__bottom-two">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="copyright-text-two">
                                    <p>Copyright © <a href="index.html">Diskominfo & Sandi</a> </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
</template>

<script>
export default {
    data() {
        return {
            URL_APP: 'https://server-web.konaweselatankab.go.id/',
            UPLOADS: 'https://server-web.konaweselatankab.go.id/uploads/',
            data_ke:1,
            cari:'',
            list_data:[],
            jml_data:0,
        };
    },
    methods:{
        getFoto() { 
            fetch(this.$store.state.URL.foto + 'view', {
                method: "POST",
                headers: {
                "content-type": "application/json", 
                }, 
                body:JSON.stringify(
                    {
                        data_ke     : this.data_ke, 
                        cari_value  : this.cari
                    }
                )
            })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data = res_data.data
                this.jml_data = res_data.jml_data
                console.log(res_data); 
            });     
        },
    },
    
    mounted() {
        this.getFoto()
        
    },
}
</script>